module.exports = __webpack_public_path__ + "assets/image-pr.png";


//////////////////
// WEBPACK FOOTER
// ./images/image-pr.png
// module id = 295
// module chunks = 0